var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgFlagsi = function SvgFlagsi(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 24 24",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#454B56",
    fillRule: "evenodd",
    d: "M4.27 13.395V21a.7.7 0 0 1-1.401 0V3.05a.7.7 0 0 1 .464-.657 1 1 0 0 1 .082-.04c2.692-1.108 5.383-1.217 8.08-.528l.012.002a2.7 2.7 0 0 1 1.986 2.606v.544c2.023.937 5.026.913 6.575-.142a.703.703 0 0 1 1.097.58v9.876c0 .249-.133.48-.348.604-2.005 1.173-4.255 1.49-6.821.678a2.66 2.66 0 0 1-1.868-2.53 55 55 0 0 1-.01-.68c-2.616-.989-5.23-.991-7.848.03m0-9.874v8.381c2.612-.904 5.224-.904 7.834-.029-.014-2.461-.012-5.631-.012-7.44 0-.584-.39-1.097-.952-1.254-2.293-.582-4.581-.523-6.87.342m9.223 2.963c0 2.512.005 5.76.037 7.54v.01c0 .551.357 1.038.884 1.202l.002.002c1.996.634 3.76.458 5.345-.36V6.543c-1.795.657-4.3.644-6.268-.058",
    clipRule: "evenodd"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgFlagsi);
export default ForwardRef;